export enum CERTIFICATESTATUS {
  EXPIRED = 'EXPIRED',
  INVALID = 'INVALID',
  VALID = 'VALID',
}
